
import { defineStore } from 'pinia';
import personalInformationRepository from '../repositories/personal_information_repository';
import { Profile } from '../api/PersonalInformationApi';
import { ref } from 'vue';

// Define and export the store
export const usePersonalInformationStore = defineStore('personal-information', () => {

      const profile = ref<Profile | null>(null);

    // Get imageUrl for a passport
    async function getPassportImageUrl(passporId: string, mitId: string): Promise<string | undefined> {
        try {
            // Call the API with the passportId as a string parameter
            const response = await personalInformationRepository.passports.passportsDetail(passporId, { mitId });
            return response.data?.imageUrl ?? undefined;
        } catch (error) {
            console.error('Error fetching programs:', error);
            throw error;
        }
    }

    // Get imageUrl for a visa
    async function getVisaImageUrl(visaId: string, mitId: string): Promise<string | undefined>  {
        try {
            // Call the API with the visaId as a string parameter
            const response = await personalInformationRepository.visas.visasDetail(visaId, { mitId });
            return response.data?.imageUrl ?? undefined;
        } catch (error) {
            console.error('Error fetching programs:', error);
            throw error;
        }
    }

    // Get imageUrl for a visa
    async function getProfile() {
        try {
            // Call the API with the visaId as a string parameter
            const response = await personalInformationRepository.profile.profileList();
            profile.value =  response.data ?? undefined;
        } catch (error) {
            console.error('Error fetching programs:', error);
            throw error;
        }
    }

    return {
        profile,
        getProfile,
        getPassportImageUrl,
        getVisaImageUrl
    };
});